module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Bold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Bold-webfont.svg
// module id = 1618
// module chunks = 0